
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/why-rust-its-the-safe-choice",
      function () {
        return require("private-next-pages/blog/why-rust-its-the-safe-choice.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/why-rust-its-the-safe-choice"])
      });
    }
  